import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { TransactionalButton } from '@bibliocommons/deprecated-base-buttons';
import ScreenReaderItemInfo from '@bibliocommons/shared-screen-reader-item-info';
import { MATERIAL_TYPE_PHYSICAL } from '../../../constants/BibConstants';

class RequestItemButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    if (this.props.availableForCheckout && this.props.materialType !== MATERIAL_TYPE_PHYSICAL) {
      this.props.handleCheckoutClick(this.props.metadataId);
    } else {
      this.props.handleHoldClick(this.props.metadataId);
    }
  }

  getDataKey() {
    if (this.props.materialType === MATERIAL_TYPE_PHYSICAL) {
      return 'place-a-hold';
    }
    if (this.props.availableForCheckout) {
      return 'checkout-now';
    }
    return 'request-this-download';
  }

  renderButtonText() {
    if (this.props.materialType === MATERIAL_TYPE_PHYSICAL) {
      return <FormattedMessage id="btn.placeAHold" />;
    }
    if (this.props.availableForCheckout) {
      return <FormattedMessage id="check_out_now" />;
    }
    return <FormattedMessage id="request_this_title" />;
  }

  render() {
    const { format, title, authors, serviceAvailable, titleNotOwned } = this.props;
    return (
      <TransactionalButton
        handleClick={this.handleClick}
        className="cp-request-item-button"
        isLoading={this.props.isLoading}
        block
        disabled={!serviceAvailable || titleNotOwned}
        dataKey={`bib-${this.getDataKey()}`}
      >
        {this.renderButtonText()}
        <ScreenReaderItemInfo format={format} title={title} authors={authors} />
      </TransactionalButton>
    );
  }
}

RequestItemButton.propTypes = {
  handleCheckoutClick: PropTypes.func.isRequired,
  handleHoldClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  availableForCheckout: PropTypes.bool,
  materialType: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authors: ImmutablePropTypes.listOf(PropTypes.string),
  metadataId: PropTypes.string.isRequired,
  titleNotOwned: PropTypes.bool,
  serviceAvailable: PropTypes.bool
};

export default RequestItemButton;
